<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter01">1. Dayton’s Blessing from the Watervliet Shakers</a></p>
<p class="TOC"><a href="#/Chapter02">2. Ghostly Graveyards</a></p>
<p class="TOC"><span href="#/Chapter03" title="Link target outside of Sample">3. Bizarre Beasts</span></p>
<p class="TOC"><span href="#/Chapter04" title="Link target outside of Sample">4. Dreadful Deaths</span></p>
<p class="TOC"><span href="#/Chapter05" title="Link target outside of Sample">5. Eerie Eateries</span></p>
<p class="TOC"><span href="#/Chapter06" title="Link target outside of Sample">6. Supernatural Stages</span></p>
<p class="TOC"><span href="#/Chapter07" title="Link target outside of Sample">7. Enduring Entities</span></p>
<p class="TOC"><span href="#/Chapter08" title="Link target outside of Sample">8. Phantom Phenomena</span></p>
<p class="TOC"><span href="#/Chapter09" title="Link target outside of Sample">9. Mysterious Matters</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">10. School Spirits</span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">11. Paranormal Parks</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">12. Haunted Houses</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">13. Weird Wright-Patterson</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">14. Terrifying Tidbits</span></p>
<p class="TOC"><span href="#/Chapter15" title="Link target outside of Sample">15. Unmasking Urban Legends</span></p>
<p class="TOC1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0896e6da